import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { usePathBuilder } from 'ciam-self-service-shared';

/**
 * Redirects to a target route while preserving query string and hash.
 * @param {{ to: string }} props - Component props.
 * @returns {React.ReactElement} A <Redirect> element; no UI is rendered.
 */
const RedirectToHome = ({ to }) => {
  const { search, hash } = useLocation();
  const pathBuilder = usePathBuilder();
  const searchParams = Object.fromEntries(new URLSearchParams(search));
  const targetPath = pathBuilder(to, true, { searchParams });
  return <Redirect to={`${targetPath}${hash || ''}`} />;
};

RedirectToHome.propTypes = {
  to: PropTypes.string.isRequired,
};

export default RedirectToHome;
